import {GameFont} from '../../../../shared/scripts/GameFont'
import {CardView} from '../../../../shared/scripts/ui_canvas_engine/CardView'
import {RibbonCountView} from '../../../../shared/scripts/ui_canvas_engine/RibbonCountView'
import {SectionView} from '../../../../shared/scripts/ui_canvas_engine/SectionView'
import {TextTruncatedView} from '../../../../shared/scripts/ui_canvas_engine/TextTruncatedView'
import {UIGamePlayerAvatarView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerAvatarView'
import {UIGamePlayerInformationView, UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {TranslationObject} from '@colonist/i18n'
import {AdaptiveSpriteSectionView} from '../../../../shared/scripts/ui_canvas_engine/AdaptiveSpriteSectionView'
import {PlayerValidator, MechanicValidatorDevelopmentCardPlayer, MechanicValidatorProgressCardsPlayer} from '@colonist/game-mechanic-validators'
import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'
import {Sprites} from '../../../../shared/scripts/ui_game/UIGameImageDictionary'
import {
    CardEnum,
    MechanicCityImprovementsPlayerState,
    MechanicCityPlayerState,
    MechanicCityWallPlayerState,
    MechanicLargestArmyPlayerState,
    MechanicLongestRoadPlayerState,
    MechanicRoadPlayerState,
    MechanicSettlementPlayerState,
    MechanicSpecialBuildPhaseState,
    PlayerState,
} from '@colonist/game-states'

export class UIWGamePlayerInformationView extends UIGamePlayerInformationView {
    constructor(uiGameManager: UIGameManager, player: PlayerValidator, playerState: PlayerState, y: number, w: number, h: number, container: PIXI.Container, myPlayer: boolean,
                developmentCardsPlayerState: MechanicValidatorDevelopmentCardPlayer | undefined,
                progressCardsPlayerValidator: MechanicValidatorProgressCardsPlayer | undefined,
                settlementPlayerState: MechanicSettlementPlayerState | undefined,
                cityPlayerState: MechanicCityPlayerState | undefined,
                cityWallPlayerState: MechanicCityWallPlayerState | undefined,
                cityImprovementPlayerState: MechanicCityImprovementsPlayerState | undefined,
                roadPlayerState: MechanicRoadPlayerState | undefined,
                longestRoadPlayerState: MechanicLongestRoadPlayerState | undefined,
                largestArmyPlayerState: MechanicLargestArmyPlayerState | undefined,
                specialBuildPhaseState: MechanicSpecialBuildPhaseState | undefined) {
        super(uiGameManager, player, playerState, 0, y, w, h, container, myPlayer,
            developmentCardsPlayerState,
            progressCardsPlayerValidator,
            settlementPlayerState,
            cityPlayerState,
            cityWallPlayerState,
            cityImprovementPlayerState,
            roadPlayerState,
            longestRoadPlayerState,
            largestArmyPlayerState,
            specialBuildPhaseState)
        this.drawRoundedBg()
        this.updateTurn()
    }

    protected createMyPlayerNameAndImage() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerNameX = this.width * 0.303
        const playerNameY = this.height * 0.0111
        const playerNameW = this.width * 0.3984
        const playerNameH = this.height * 0.3444
        const removePadding = true
        const section = new SectionView(playerNameX, playerNameY, playerNameW, playerNameH, this, removePadding)
        this.playerName = new TextTruncatedView({key: 'strings:colonistCommon.utils.emptyString'}, 0, 0, section.width, section.height, section, GameFont.Size.XL)
        this.playerName.changeStyle({align: 'left'})

        const playerAvatarX = this.width * 0.0598
        const playerAvatarY = this.height * 0.2667
        const playerAvatarW = this.width * 0.2147
        this.playerAvatar = new UIGamePlayerAvatarView(playerAvatarX, playerAvatarY, playerAvatarW, this, this.player)

        const largeRibbon = true
        const victoryPointRibbonX = playerAvatarX
        const victoryPointRibbonY = this.height * 0.7547
        const victoryPointRibbonW = playerAvatarW
        const victoryPointRibbonH = this.height * 0.1906
        this.victoryPointRibbon = new RibbonCountView(victoryPointRibbonX, victoryPointRibbonY, victoryPointRibbonW, victoryPointRibbonH, this, largeRibbon)
        const vpToWin = this.uiGameManager.gameController.gameSettings.victoryPointsToWin
        const vpToWinTooltipTitle: TranslationObject = {key: 'strings:game.playerInformation.victoryPoint.title'}
        const vpToWinTooltipBody: TranslationObject = {
            key: 'strings:game.playerInformation.victoryPoint.body',
            options: {count: vpToWin},
        }
        this.victoryPointRibbon.setTip(vpToWinTooltipTitle, [vpToWinTooltipBody])

        this.createMyCardSection()
    }

    protected updateTextView() {
        this.playerName.setText({key: 'strings:colonistCommon.utils.#buffer', options: {value: this.player.username}})
        this.playerName.centerXInParent()
    }

    private createMyCardSection() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const resourceCardCount = 0
        const resourceCardX = this.width * 0.3354
        const resourceCardY = this.height * 0.4444
        const cardW = this.width * 0.1209
        const cardH = this.height * 0.4611
        this.resourceCardView = new CardView(this.uiGameManager, resourceCardCount, resourceCardX, resourceCardY, cardW, cardH, CardEnum.ResourceBack, this)
        this.updateResourceCardTip()

        const developmentCardCount = 0
        const developmentCardX = this.width * 0.4736
        const developmentCardY = resourceCardY
        const forceCardBadge = true
        this.developmentCardView = new CardView(this.uiGameManager, developmentCardCount, developmentCardX, developmentCardY, cardW, cardH, CardEnum.DevelopmentBack, this, undefined, forceCardBadge)
        const developmentCardTipTitle: TranslationObject = {key: 'strings:game.playerInformation.developmentCard.title'}
        const developmentCardTipBody: TranslationObject = {key: 'strings:game.playerInformation.developmentCard.body'}
        this.developmentCardView.view.setTip(developmentCardTipTitle, [developmentCardTipBody])
    }

    protected createMySpecialIconView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const specialIconViewX = this.width * 0.0398
        const specialIconViewY = this.height * 0.025
        const specialIconViewW = this.width * 0.2547
        const specialIconViewH = this.height * 0.24

        const isPrimaryAxisHorizontal = true
        this.specialIconView = new AdaptiveSpriteSectionView(specialIconViewX, specialIconViewY, specialIconViewW, specialIconViewH, this, isPrimaryAxisHorizontal)
    }

    protected createOpponentPlayerNameAndImage() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerAvatarX = this.width * 0.1069
        const playerAvatarY = this.height * 0.2759
        const playerAvatarW = this.width * 0.1238
        const removePadding = true
        this.playerAvatar = new UIGamePlayerAvatarView(playerAvatarX, playerAvatarY, playerAvatarW, this, this.player)

        const largeRibbon = false
        const victoryPointRibbonX = this.width * 0.1077
        const victoryPointRibbonY = this.height * 0.66
        const victoryPointRibbonW = this.width * 0.122
        const victoryPointRibbonH = this.height * 0.2586
        this.victoryPointRibbon = new RibbonCountView(victoryPointRibbonX, victoryPointRibbonY, victoryPointRibbonW, victoryPointRibbonH, this, largeRibbon)
        const vpToWin = this.uiGameManager.gameController.gameSettings.victoryPointsToWin
        const vpToWinTooltipTitle: TranslationObject = {key: 'strings:game.playerInformation.victoryPoint.title'}
        const vpToWinTooltipBody: TranslationObject = {
            key: 'strings:game.playerInformation.victoryPoint.body',
            options: {count: vpToWin},
        }
        this.victoryPointRibbon.setTip(vpToWinTooltipTitle, [vpToWinTooltipBody])

        const playerNameSectionX = this.width * 0.0142
        const playerNameSectionY = this.height * 0.0517
        const playerNameSectionW = this.width * 0.311
        const playerNameSectionH = this.height * 0.2069
        const playerNameSection = new SectionView(playerNameSectionX, playerNameSectionY, playerNameSectionW, playerNameSectionH, this, removePadding)
        this.playerName = new TextTruncatedView({key: 'strings:colonistCommon.utils.emptyString'}, 0, 0, playerNameSectionW, playerNameSectionH, playerNameSection)

        this.createOpponentCardSection()
        this.createOpponentSpecialIconView()
    }

    private createOpponentCardSection() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const resourceCardCount = 0
        const resourceCardX = this.width * 0.3354
        const resourceCardY = this.height * 0.1422
        const cardW = this.width * 0.1222
        const cardH = this.height * 0.7155
        this.resourceCardView = new CardView(this.uiGameManager, resourceCardCount, resourceCardX, resourceCardY, cardW, cardH, CardEnum.ResourceBack, this)

        const resourceCardViewTipTitle: TranslationObject = {key: 'strings:game.playerInformation.resourceCard.title'}
        const resourceCardViewTipBody: TranslationObject = {
            key: 'strings:game.playerInformation.resourceCard.body',
            options: {context: this.uiGameManager.gameState.gameModeData.translationKeyContext},
        }
        this.resourceCardView.view.setTip(resourceCardViewTipTitle, [resourceCardViewTipBody])

        const developmentCardCount = 0
        const developmentCardX = this.width * 0.4736
        const developmentCardY = resourceCardY
        const forceCardBadge = true
        this.developmentCardView = new CardView(this.uiGameManager, developmentCardCount, developmentCardX, developmentCardY, cardW, cardH, CardEnum.DevelopmentBack, this, undefined, forceCardBadge)
        const developmentCardViewTipTitle: TranslationObject = {key: 'strings:game.playerInformation.developmentCard.title'}
        const developmentCardViewTipBody: TranslationObject = {key: 'strings:game.playerInformation.developmentCard.body'}
        this.developmentCardView.view.setTip(developmentCardViewTipTitle, [developmentCardViewTipBody])
    }

    private createOpponentSpecialIconView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const specialIconViewX = this.width * 0.0183
        const specialIconViewY = this.height * 0.2759
        const specialIconViewW = this.width * 0.0772
        const specialIconViewH = this.height * 0.6628

        const isPrimaryAxisHorizontal = false
        this.specialIconView = new AdaptiveSpriteSectionView(specialIconViewX, specialIconViewY, specialIconViewW, specialIconViewH, this, isPrimaryAxisHorizontal)
    }

    protected updateTurn() {
        const playerToHighlight = this.getPlayerToHighlight()
        this.player.color == playerToHighlight ? this.drawRoundedBg() : this.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_player_inactive))
    }

    getContainerForAdditionalPlayerInformation(layerIndex: UIPlayerAdditionalInformationLayer): PIXI.Container {
        return this
    }
}
